import React from 'react'
import { Box, Link, SvgIcon } from '@mui/material'

interface DealsLinkProps {
    locale: string
    t: (key: string) => string
    hidden?: boolean
    variant: 'flyin' | 'cleartrip'
}

const DealsLink: React.FC<DealsLinkProps> = ({ locale, t, hidden = false, variant }) => {
    if (hidden) return null

    const href = variant === 'flyin' ? `/${locale}/offers` : '/offers'

    const sx = variant === 'flyin'
        ? {
              position: 'relative',
              display: { xs: 'none', sm: 'none', md: 'flex' },
              alignItems: 'center',
              fontSize: 14,
              fontWeight: 500,
              color: '#1a2a3a',
              '&:hover': { color: '#194E91' },
              transition: 'color 0.2s',
              marginRight: '6px',
              px: 0.7
          }
        : {
              display: 'flex',
              alignItems: 'center',
              fontSize: 14,
              fontWeight: 500,
              color: 'text.secondary',
              '&:hover': { color: 'primary.main' },
              transition: 'color 0.2s',
              marginRight: '6px',
              px: 0.7
          }

    return (
        <Link href={href} underline="none" sx={sx}>
            <Box sx={{ mr: 0.7, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <SvgIcon sx={{ width: 17, height: 17 }}>
                    <svg width="17" height="17" fill="none" viewBox="0 0 24 24">
                        <path
                            d="M4 7V6a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v1"
                            stroke={variant === 'flyin' ? '#1a2a3a' : 'currentColor'}
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <rect
                            width="20"
                            height="13"
                            x="2"
                            y="7"
                            rx="2"
                            stroke={variant === 'flyin' ? '#1a2a3a' : 'currentColor'}
                            strokeWidth="1.3"
                        ></rect>
                        <circle cx="17" cy="12" r="1" fill={variant === 'flyin' ? '#1a2a3a' : 'currentColor'}></circle>
                    </svg>
                </SvgIcon>
            </Box>
            {t('deals')}
        </Link>
    )
}

export { DealsLink }
export type { DealsLinkProps }
